import { Form } from 'factorial-form'

class ReportForm extends Form {
  constructor(values: Record<string, any>) {
    super(values, {
      id: 'number',
      dashboard_id: 'number',
      title: 'string',
      chart_type: 'string',
      initial_data: 'string',
      secondary_data: 'string',
      tertiary_data: 'string',
    })
  }
}

export default ReportForm
